import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { buildBootstrapAppConfig } from './app/auth/auth-bootstrap-config';

bootstrapApplication(AppComponent, buildBootstrapAppConfig(appConfig))
  .catch((err) => console.error(err));
